import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import HowShipAndStorageWorksPage from '@/v2/components/pages/public-pages/how-ship-and-storage-works-page'
import { metaImages, ogImages } from '@/v2/constants/pages/public-pages/how-ship-and-storage-works'

const HowShipAndStorageWorks = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.how_ship_and_storage_works.title}
        keywords={META_CONTENTS.how_ship_and_storage_works.keywords}
        description={META_CONTENTS.how_ship_and_storage_works.description}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <HowShipAndStorageWorksPage />
    </>
  )
}

export default HowShipAndStorageWorks
